export function getImageSrc(imageName: string): string {
  if (window.location.hostname === 'localhost') {
    return `/assets/${imageName}`;
  }
  return `https://vstatic-prod.apigateway.co/partner-center-client/assets/${imageName}`;
}

/**
 * A mapping of PaymentCardTypes to the image source for the credit card picture.
 */
export const paymentCardImageUrls = {
  Visa: getImageSrc('images/icons/visa.png'),
  'American Express': getImageSrc('images/icons/amex.png'),
  Mastercard: getImageSrc('images/icons/mastercard.png'),
  Discover: getImageSrc('images/icons/discover.png'),
};
